import { createFileRoute } from '@tanstack/react-router'
import { FormTemplateEditor } from '../components/form-template-versions/form-template-version-editor/FormTemplateEditor'

export const Route = createFileRoute('/_a/templates/$templateId/edit')({
  component: FormTemplateEditor,
})
